<template>
  <el-container :class="rootClassList">
    <el-header
      class="PageContainer-header"
      height="auto"
    >
      <div class="responsive-main">
        <page-header>
          <slot name="page-actions"></slot>
        </page-header>
        <slot name="page-tabs"></slot>
      </div>
    </el-header>
    <el-main class="PageContainer-main">
      <div class="responsive-main">
        <slot></slot>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import PageHeader from './PageHeader.vue'

/**
 * Conteneur de page
 */
export default {
  name: 'UbiPageContainer',
  inject: ['browserContext'],
  components: {
    PageHeader
  },
  props: {
    /**
     * Élargit la zone principale (~95 % de la largeur utile) au lieu du gabarit fixe du `UserLayout` (1080px).
     * Désactivé par défaut pour éviter les effets de bord ; activer avec `wide-main-content` sur les pages concernées.
     */
    wideMainContent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rootClassList () {
      const classes = []
      if (this.$route.name === 'tutoralsVideos') {
        classes.push('background-videos')
      }
      classes.push('PageContainer')
      if (this.wideMainContent) {
        classes.push('PageContainer--wideMain')
      }
      return classes
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.background-videos{
  min-height: 780px;
  //background-image: url("../assets/fond-pour-EC-tuto-72dpi.png");
  //background-position: center;
  //background-size: 70%;
  //background-color: #1e4a56;
}

.PageContainer {
  position: relative;
  width: 100%;
  &-header {
    @extend .p-0;
    align-items: center;
    background-color: $body-bg;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: $layout-z-header - 1;
    display: flex;
    justify-content: center;

    .responsive-main {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
      min-height: auto;
      width: 100%;
    }
  }

  .el-tabs {
    &__nav-prev,
    &__nav-next {
      color: $layout-header-bg;
      font-size: 16px;
      text-align: center;
      width: map-get($spacers, 4);
    }
    &__nav-wrap {
      @extend .px-4;
    }
  }

  &-main {
    @extend .px-0, .pt-5, .pb-0;
  }

  @include media-breakpoint-up(md) {
    &-header {
      background-position: -50px -50px;
    }
  }

  @include media-breakpoint-up(xl) {
    &-header {
      background-color: $body-bg;
      min-height: auto;
    }

    .responsive-main {
      min-height: auto;
    }
  }

  @include media-breakpoint-down(sm) {
    &-header {
      background-position: -50 -50;
      background-repeat: no-repeat;
      left: 0;
      position: sticky;
      right: 0;
      top: 0;
      z-index: $layout-z-header - 1;
      min-height: 0;

      .responsive-main {
        width: 100%;
        min-height: 0;
      }
    }

    &-main {
      padding: map-get($spacers, 3) !important;
    }

    .el-tabs {
      &__nav-prev,
      &__nav-next {
        line-height: 32px;
      }
    }
  }
}

/* Zone principale élargie (opt-in : prop wideMainContent sur ce composant) */
.UserLayout .PageContainer.PageContainer--wideMain {
  @include media-breakpoint-up(md) {
    .responsive-main {
      width: 95% !important;
      max-width: none !important;
      margin: 0 auto;
    }
  }

  @include media-breakpoint-up(lg) {
    .responsive-main {
      width: 95% !important;
      max-width: none !important;
      margin: 0 auto;
    }
  }

  /* Fils direct uniquement : ne pas toucher aux <el-main> imbriqués (panels, etc.) */
  > .el-main {
    padding: 0;
    width: 95% !important;
    max-width: none !important;
    margin: 0 auto;
  }
}
</style>

<docs>
### Zone principale élargie (`wide-main-content`)

Par défaut le contenu suit le gabarit du `UserLayout` (largeur fixe sur grands écrans).
Pour utiliser ~95 % de la largeur disponible (comme les listes contacts, exports, etc.) :

```html
<ubi-page-container wide-main-content>
  …
</ubi-page-container>
```

Ne pas activer sur une page qui doit rester au gabarit étroit (comportement historique).
</docs>
